export function setOfferYear(state, payload) {
  state.offerYear = payload;
}

export function setHasKnownIban(state, payload) {
  state.hasKnownIban = payload;
}

export function setHasIbanPayedByInsured(state, payload) {
  state.hasIbanPayedByInsured = payload;
}

export function clearOfferYear(state) {
  state.offerYear = undefined;
}

export function setAgreements(state, payload) {
  state.agreements = payload;
}

export function clearAgreementDetails(state) {
  state.agreementDetails = undefined;
}
export function clearAgreements(state) {
  state.agreements = undefined;
}

export function setIsLoadingAgreements(state, payload) {
  state.isLoadingAgreements = payload;
}

export function setNotShowAnymore(state) {
  state.notShowAnyMore = true;
}
export function setAgreementDetails(state, payload) {
  state.agreementDetails = payload;
}

export function setAgreementDetailsForOfferYear(state, payload) {
  state.agreementDetailsForOfferYear = payload;
}

export function addPolicyToAgreementDetails(state, payload) {
  if (state.agreementDetails) {
    state.agreementDetails.forEach((agreementDetail) => {
      agreementDetail.agreementParticipants.forEach((agreementParticipant) => {
        if (agreementParticipant.policyNumber === payload.policyNumber) {
          agreementParticipant.customer = agreementParticipant.customer.addPolicy(payload.policy);
        }
      });
    });
  }
}

export function addPoliciesToAgreementDetails(state, payload) {
  if (state.agreementDetails) {
    state.agreementDetails.forEach((agreementDetail) => {
      const activeAgreementDetail = payload.find((x) => x.agreementId === agreementDetail.agreementId);
      agreementDetail.agreementParticipants.forEach((agreementParticipant) => {
        const policyDetail = activeAgreementDetail.policyDetails.find(
          (x) => x.policyNumber === agreementParticipant.policyNumber,
        );
        if (policyDetail) {
          agreementParticipant.customer = agreementParticipant.customer.addPolicy(policyDetail);
        }
      });
    });
  }
}

export function addPoliciesToAgreementDetailsForOfferYear(state, payload) {
  if (state.agreementDetailsForOfferYear) {
    state.agreementDetailsForOfferYear.forEach((agreementDetail) => {
      const activeAgreementDetail = payload.find((x) => x.agreementId === agreementDetail.agreementId);
      agreementDetail.agreementParticipants.forEach((agreementParticipant) => {
        const policyDetail = activeAgreementDetail.policyDetails.find(
          (x) => x.policyNumber === agreementParticipant.policyNumber,
        );
        if (policyDetail) {
          agreementParticipant.customer = agreementParticipant.customer.addPolicy(policyDetail);
        }
      });
    });
  }
}

export function setPaymentDetails(state, payload) {
  state.agreements.forEach((agreement) => {
    if (agreement.agreementId === payload.id) {
      if (!agreement.paymentDetails) {
        agreement = agreement.addPaymentDetails(payload.details);
      }
    }
  });
}

export function updateMedicalSelectionForAgreementParticipant(state, payload) {
  state.agreementDetails.forEach((agreementDetail) => {
    if (agreementDetail.agreementId === payload.agreementId) {
      agreementDetail.agreementParticipants.forEach((participant) => {
        if (participant.customer.customerNumber === payload.customerNumber) {
          payload.medicalSelection.policyNumber = payload.policyNumber;
          participant.customer.medicalSelection = payload.medicalSelection;

          if (payload.medicalSelection.hasCongenitalDentalDefect?.key) {
            ModifyMedicalSelectionForBackend(participant.customer.medicalSelection, payload.medicalSelection);
          }
        }
      });
    }
  });
}

export function ModifyMedicalSelectionForBackend(toMedicalSelection, fromMedicalSelection) {
  toMedicalSelection.hasCongenitalDentalDefect = fromMedicalSelection.hasCongenitalDentalDefect?.key === 'yes';
  toMedicalSelection.orthodonticsWithinTwoYears = fromMedicalSelection.orthodonticsWithinTwoYears?.key === 'yes';
  toMedicalSelection.dentistLastTwoYears = fromMedicalSelection.dentistLastTwoYears?.key === 'yes';
  toMedicalSelection.extracted4OrMoreTeeth = fromMedicalSelection.extracted4OrMoreTeeth?.key === 'yes';
  toMedicalSelection.expectsToHaveOneOfFollowingTreatments = fromMedicalSelection.expectsToHaveOneOfFollowingTreatments
    .filter((x) => x.key !== 0)
    .map((x) => x.key);
  toMedicalSelection.doesNotExpectTreatment =
    fromMedicalSelection.expectsToHaveOneOfFollowingTreatments?.filter((x) => x.key !== 0).length === 0;
}

export function updateEditPolicyDenialReasons(state, payload) {
  state.agreementDetails.forEach((agreementDetail) => {
    payload.contractMutabilities.forEach((contract) => {
      if (agreementDetail.contractCode === contract.contractCode) {
        agreementDetail = agreementDetail.updateEditPolicyDenialReason(
          payload.currentUser,
          contract.isMutable,
          payload.policyYear,
        );
      }
    });
  });
}

export function setHasLoadedEditPossible(state, payload) {
  state.hasLoadedEditPossible = payload;
}

export function setHasBasicInsurance(state, payload) {
  state.hasBasicInsurance = payload;
}
